const binding = { modules: {}, dataActions: {} };

    (binding.modules['unbxd-search'] = {
        c: () => require('partner/modules/unbxd-search/unbxd-search.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'unbxd-search',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/unbxd-search'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|unbxd-search|unbxd-search'] = {
                c: () => require('partner/modules/unbxd-search/unbxd-search.view.tsx'),
                cn: '__local__-__local__-unbxd-search'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };